<!--
 * @Author: your name
 * @Date: 2021-12-09 10:55:19
 * @LastEditTime: 2022-07-18 10:52:52
 * @LastEditors: ttheitao
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \dataview-viewer-test\src\views\qualityMeter\index.vue
-->

<template>
  <div class="pc-content" v-if="!isMobile">
    <img src ='https://openim-1309784708.cos.ap-shanghai.myqcloud.com/abb9269534dd046323a1965f6372f8b3.png' />
    <div class="box">
      <div class="title">
        文件分享
      </div>
      <el-input v-model="pwd" placeholder="请输入提取码"></el-input>
      <el-button class="btn" @click="confirm">提取文件</el-button>
      <div class="error-text shake" v-if="showError">
        <i class="rafterfont rafter-icon-weijihuo"></i>
        <span>{{ errorText }}</span>
      </div>
    </div>
  </div>
  <div v-else class="h5-content">
    <div class="header">
      <p>
        筑云分享
      </p>
    </div>
    <div class="title">
      文件分享
    </div>
    <div class="box">
      <el-input v-model="pwd" placeholder="请输入提取码" class="radius input" style="::placeholder { font-size: 18px; }"></el-input>
      <el-button class="btn radius" type="primary" @click="confirm">提取文件</el-button>
      <div class="error-text shake" v-if="showError">
        <i class="rafterfont rafter-icon-weijihuo"></i>
        <span>{{ errorText }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Menu, MenuItem,Link,  } from "element-ui";
import { dataInterface } from "@/apis/data/index";
export default {
  components: {
  },
  data() {
    return {
      pwd: '',
      isMobile: false,
      currentParams: {},
      showError: false,
      errorText: '这是一段问题',
    };
  },
  computed: {},
  watch: {
    
  },
  created() {
    this.isMobile= /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.init()
  },
  mounted() {
  },
  methods: {
    confirm() {
      this.showError = false
      if( this.pwd !== this.currentParams.secret){
        this.showError = true
        this.errorText = '提取码错误!'
        this.$nextTick(()=>{
            // 获取元素
          const textElement = document.querySelector('.error-text');
          // 开始抖动
          textElement.classList.add('shake');
          // 停止抖动
          setTimeout(() => {
            textElement.classList.remove('shake');
          }, 200); 
        })
        return;
      }
      const otherKeyJson = JSON.parse(this.currentParams.otherKey);
      const otherKeyParams = new URLSearchParams(otherKeyJson).toString();
      let newUrl
      if(this.isMobile){
        newUrl = `${window.location.origin}/h5/new-page-parser?page_uuid=${this.currentParams.h5PageUrl}&${otherKeyParams}`;
      }else{
        newUrl = `${window.location.origin}/dataview/show?pageUUID=${this.currentParams.pcPageUrl}&${otherKeyParams}`;
      }
      console.log(newUrl, 'newUrl')
      window.location.href = newUrl;
    },
    init() {
      this.currentParams = {};
      const queryString = window.location.search;
      if (queryString) {
        new URLSearchParams(queryString).forEach((value, key) => {
          this.currentParams[key] = value;
        });
      }
      if(!this.currentParams.secret){
        if(!this.currentParams.effectiveDate){
          this.confirm()
        }else{
          const effectiveDate = new Date(this.currentParams.effectiveDate);
          const currentDate = new Date();
          if (effectiveDate > currentDate) {
            this.confirm()
          }
        }
      }

      if(this.currentParams.effectiveDate){
        const effectiveDate = new Date(this.currentParams.effectiveDate);
        const currentDate = new Date();
        if (effectiveDate < currentDate) {
          this.showError = true
          this.errorText = '该文件已过期!'
            nextTick(()=>{
              // 获取元素
              const textElement = document.querySelector('.error-text');
              // 开始抖动
              textElement.classList.add('shake');
              // 停止抖动
              setTimeout(() => {
                textElement.classList.remove('shake');
              }, 200); 
            })
        }
      }
    }
  },
};
</script>
<style lang="less" scoped>
.pc-content{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 240px;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.70) 50%, rgba(255, 255, 255, 0.80) 100%), var(--semantic-brand-background, #E7F0FE);
  .box{
    margin-top: 32px;
    display: flex;
    width: 480px;
    height: 256px;
    padding: 48px 56px;
    padding-bottom: 20px;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    gap: 20px;
    flex-shrink: 0;
    border-radius: 16px;
    background: var(--overall-surface-default, #FFF);
    box-shadow: 0px 4px 16px -4px rgba(21, 24, 67, 0.08);
    .title{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      align-self: stretch;
      color: var(--sys-text-text-primary, #161C1F);
      font-family: "Source Han Sans CN";
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 26px; /* 144.444% */
      letter-spacing: 0.5px;
    }
    .btn{
      display: flex;
      width: 368px;
      height: 40px;
      padding: 5px 48px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      box-sizing: border-box;
    }
  }
  .error-text{
    color: var(--text-on-surface-required, #ED474A);
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    gap: 8px;
  }
}


.h5-content{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.70) 50%, rgba(255, 255, 255, 0.80) 100%), var(--semantic-brand-background, #E7F0FE);
  .header{
    display: flex;
    width: 100%;
    height: 44px;
    padding: 10px 9px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0; 
    p{
      color: var(--text-on-surface-primary, #181B22);
      text-align: center;
      /* EMTitle / PINGFANG SC */
      font-family: "PingFang SC";
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
  .title{
    display: flex;
    padding: 0px 20px;
    align-items: center;
    gap: 12px;
    overflow: hidden;
    color: var(--text-on-surface-primary, #181B22);
    text-overflow: ellipsis;
    font-family: "PingFang SC";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    margin-bottom: 16px;
    box-sizing: border-box;
    margin-top: 12px;
  }
  .box{
    display: flex;
    flex: 1;
    box-sizing: border-box;
    padding: 120px 39px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    flex-shrink: 0;
    border-radius: 20px 20px 0px 0px;
    background: var(--overall-surface-default, #FFF);
    box-shadow: 0px 0px 2px -1px rgba(61, 64, 102, 0.12);
    box-sizing: border-box;
    :deep(.input-box){
      display: flex;
      padding: 13px;
      align-items: center;
      font-size: 18px;
      gap: 8px;
      background: var(--overall-surface-variant, #F8F9FD);
      border-radius: 48px;
      height: 56px;
      .ra-input::placeholder {
        font-size: 18px;
      }
    }
    .btn{
      display: flex;
      width: 100%;
      box-sizing: border-box;
      padding: 16px 0px 13px 0px;
      margin-top: 18px;
      justify-content: center;
      align-items: center;
      color: #FFF;
      /* web/cn/heading/heading-02 */
      font-family: "PingFang SC";
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%; /* 24px */
      letter-spacing: 0.5px;
      height: 56px;
    }
    .radius{
      border-radius: 48px;
    }
  }
  .error-text{
    color: var(--text-on-surface-required, #ED474A);
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    font-size: 18px;
    gap: 8px;
  }

}
/* 定义抖动动画 */
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-10px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(10px);
  }
}

/* 应用抖动效果的类 */
.shake {
  animation: shake 0.5s linear infinite;
  display: inline-block; /* 确保元素可以应用 transform */
}

/* 可选：停止抖动效果 */
.shake.stop {
  animation: none;
}
</style>
